document.addEventListener('DOMContentLoaded', function () {
  var videos = document.querySelectorAll('video[data-lazy-autoplay="true"]');
  if (!videos.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var video = entry.target;
      video.preload = 'auto';
      video.play().catch(function () {});
      observer.unobserve(video);
    });
  }, { rootMargin: '200px' });

  videos.forEach(function (video) {
    observer.observe(video);
  });
});
